import { render } from "./ICU.vue?vue&type=template&id=59056181&scoped=true"
import script from "./ICU.vue?vue&type=script&lang=js"
export * from "./ICU.vue?vue&type=script&lang=js"

import "./ICU.vue?vue&type=style&index=0&id=59056181&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59056181"]])

export default __exports__